var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBalanceIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Balance"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 6",
    opacity: 0.5,
    d: "M5.31961 31.3187L24.9782 25.9367L44.6368 20.5547C47.546 31.6478 41.1028 43.0502 30.2457 46.0226C19.3886 48.995 8.22877 42.4119 5.31961 31.3187Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 15",
    cx: 15.7699,
    cy: 21.0149,
    rx: 7.0922,
    ry: 7.24638,
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBalanceIcon);
export default __webpack_public_path__ + "static/media/BalanceIcon.0d83de6da38c4aaed8112dae0594739e.svg";
export { ForwardRef as ReactComponent };